// extracted by mini-css-extract-plugin
export default {"panelTitle":"panel_panelTitle__Byk5b","panelContainer":"panel_panelContainer__OP1+e","children":"panel_children__uTIyb"};